var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    stroke: "currentColor",
    viewBox: "0 0 200 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110 567H90L42 132c-2-18-2-32-2-42 0-20 5-41 16-55 14-13 27-20 44-20s30 7 44 20c11 14 16 35 16 55 0 10 0 24-2 42zm-10 73a60 60 0 1 1 0 120 60 60 0 1 1 0-120z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation2);
export default __webpack_public_path__ + "static/media/exclamation2.34bd19a1c10a088c0f4a2885c6be0daa.svg";
export { ForwardRef as ReactComponent };